import { render, staticRenderFns } from "./imageCarousel.vue?vue&type=template&id=b90c1890&"
import script from "./imageCarousel.vue?vue&type=script&lang=js&"
export * from "./imageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b90c1890')) {
      api.createRecord('b90c1890', component.options)
    } else {
      api.reload('b90c1890', component.options)
    }
    module.hot.accept("./imageCarousel.vue?vue&type=template&id=b90c1890&", function () {
      api.rerender('b90c1890', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-20POGN8p11L2j/JS/imageCarousel.vue"
export default component.exports